// Libraries
import { Chart } from 'angular-highcharts';
import { Options } from 'highcharts';

// Enums
import { FontFamilyType } from '../../shared/enums/font-family.enum';

export class HighchartsHelper {
	static getGaugeOptions() {
		let gaugeOptions: Options = {
			chart: {
				type: 'gauge',
				plotBackgroundColor: null,
				plotBackgroundImage: null,
				plotBorderWidth: 0,
				plotShadow: false,
				style: {
					fontFamily: FontFamilyType.POPPINS,
				},
			},

			title: {
				text: null,
				style: {
					fontSize: '',
					fontWeight: '',
					color: '',
				},
			},

			pane: {
				startAngle: -150,
				endAngle: 150,
				size: '98%',
				background: [
					{
						backgroundColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, '#FFF'],
								[1, '#333'],
							],
						},
						borderWidth: 0,
						outerRadius: '109%',
					},
					{
						backgroundColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, '#333'],
								[1, '#FFF'],
							],
						},
						borderWidth: 1,
						outerRadius: '107%',
					},
					{
						// default background
					},
					{
						backgroundColor: '#DDD',
						borderWidth: 0,
						outerRadius: '105%',
						innerRadius: '103%',
					},
				],
			},

			yAxis: {
				min: 0,
				max: 200,
				minorTickInterval: 'auto',
				minorTickWidth: 1,
				minorTickLength: 10,
				minorTickPosition: 'inside',

				tickPixelInterval: 30,
				tickWidth: 2,
				tickPosition: 'inside',
				tickLength: 10,

				labels: {
					step: 2,
					rotation: 0,

					style: {
						color: '',
					},
				},

				title: {
					text: null,
					style: {
						fontSize: '16px',
					},
				},

				plotBands: [
					{
						from: 0,
						to: 40,
						color: '#DF5353',
					},
					{
						from: 40,
						to: 80,
						color: '#DDDF0D',
					},
					{
						from: 80,
						to: 120,
						color: '#ffffff',
					},
					{
						from: 120,
						to: 160,
						color: '#DDDF0D',
					},
					{
						from: 160,
						to: 200,
						color: '#DF5353',
					},
				],
			},

			exporting: {
				enabled: false,
			},

			credits: {
				enabled: false,
			},

			series: [
				{
					name: '',
					type: 'gauge',
					data: [],
					tooltip: {
						valueSuffix: ' ',
					},

					dataLabels: {
						enabled: false,
						borderWidth: 0,
						style: {
							fontWeight: '',
							fontSize: '',
						},
					},
				},
			],

			accessibility: {
				enabled: false,
			},

			plotOptions: {
				gauge: {
					dial: {
						backgroundColor: '',
					},
				},
			},
		};

		return gaugeOptions;
	}

	static getBulletOptions() {
		let gaugeOptions: Options = {
			chart: {
				type: 'bullet',
				inverted: false,
				style: {
					fontFamily: FontFamilyType.POPPINS,
				},
			},
			title: {
				text: null,
				style: {
					color: '',
				},
			},

			pane: {
				startAngle: -150,
				endAngle: 150,
				size: '98%',
				background: [
					{
						backgroundColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, '#FFF'],
								[1, '#333'],
							],
						},
						borderWidth: 0,
						outerRadius: '109%',
					},
					{
						backgroundColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, '#333'],
								[1, '#FFF'],
							],
						},
						borderWidth: 1,
						outerRadius: '107%',
					},
					{
						// default background
					},
					{
						backgroundColor: '#DDD',
						borderWidth: 0,
						outerRadius: '105%',
						innerRadius: '103%',
					},
				],
			},

			plotOptions: {
				series: {
					// pointPadding: 0.25, // TODO By Isaac, this was giving error. Look into it
					borderWidth: 0,
					color: '',
					// targetOptions: { // TODO By Isaac, this was giving error. Look into it
					//     width: '300%',
					//     height: 7
					// }
				},
			},

			legend: {
				enabled: false,
			},

			yAxis: {
				gridLineWidth: 0,
				min: 0,
				max: 200,

				labels: {
					step: 2,
					rotation: 0,
					enabled: true,
					reserveSpace: false,
				},

				title: {
					text: null,
					style: {
						fontSize: '16px',
						display: 'none',
						color: '',
					},
				},

				plotBands: [
					{
						from: 0,
						to: 40,
						color: '#DF5353',
					},
					{
						from: 40,
						to: 80,
						color: '#DDDF0D',
					},
					{
						from: 80,
						to: 120,
						color: '#ccc',
					},
					{
						from: 120,
						to: 160,
						color: '#DDDF0D',
					},
					{
						from: 160,
						to: 200,
						color: '#DF5353',
					},
				],
			},

			exporting: {
				enabled: false,
			},

			credits: {
				enabled: false,
			},

			series: [
				{
					name: '',
					type: 'bullet',
					data: [
						{
							y: 0,
							target: null,
						},
					],
					tooltip: {
						valueSuffix: ' ',
					},

					dataLabels: {
						enabled: true,
						borderWidth: 0,
						style: {
							fontWeight: '',
							fontSize: '',
							color: '',
						},
						format: '{point.target}',
					},
				},
			],
			accessibility: {
				enabled: false,
			},
		};

		return gaugeOptions;
	}

	static getScatterPlotOptions() {
		let scatterPlotOptions: Options = {
			chart: {
				type: 'scatter',
				style: {
					fontFamily: FontFamilyType.POPPINS,
				},
				zooming: {
					type: 'xy',
				},
			},
			title: {
				text: null,
			},
			subtitle: {
				text: null,
			},
			xAxis: {
				title: {
					text: null,
					style: {
						color: '',
					},
				},
				labels: {
					style: {
						color: '',
					},
				},
				startOnTick: true,
				endOnTick: true,
				showLastLabel: true,
			},
			yAxis: {
				title: {
					text: null,
					style: {
						color: '',
					},
				},
				labels: {
					style: {
						color: '',
					},
				},
			},
			legend: {
				layout: 'vertical',
				align: 'left',
				verticalAlign: 'top',
				x: 100,
				y: 70,
				floating: true,
				backgroundColor: null,
				borderWidth: 1,
			},
			plotOptions: {
				scatter: {
					marker: {
						radius: 5,
						states: {
							hover: {
								enabled: true,
								lineColor: 'rgb(100,100,100)',
							},
						},
					},
					states: {
						// hover: {
						//     marker: {
						//         enabled: false
						//     }
						// }
					},
					tooltip: {
						headerFormat: '<b style="color: #8C8C8C">{point.key}</b><br>',
						pointFormat: '<div style="color: #8C8C8C">{point.x}, {point.y}</div>',
					},
				},
				series: {
					stickyTracking: false,
				},
			},
			credits: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			series: [
				{
					name: '',
					color: 'rgba(119, 152, 191, .5)',
					type: 'scatter',
					showInLegend: false,
					data: [
						{ name: 'Point 1', x: 1, y: 2 },
						{ name: 'Point 2', x: 4, y: 5 },
					],
				},
			],
			accessibility: {
				enabled: false,
			},
		};

		return scatterPlotOptions;
	}

	static getSplinePlotOptions() {
		let splinePlotOptions: Options = {
			chart: {
				type: 'spline',
				style: {
					fontFamily: FontFamilyType.POPPINS,
				},
				zooming: {
					type: 'xy',
				},
				resetZoomButton: {
					theme: {
						style: {
							color: '',
						},
					},
				},
			},
			title: {
				text: null,
			},
			subtitle: {
				text: null,
			},
			xAxis: {
				title: {
					text: null,
				},
				labels: {
					style: {
						color: '',
					},
				},
				startOnTick: true,
				endOnTick: true,
				showLastLabel: true,
			},
			yAxis: {
				title: {
					text: null,
				},
			},
			legend: {
				layout: 'vertical',
				align: 'left',
				verticalAlign: 'top',
				x: 100,
				y: 70,
				floating: true,
				backgroundColor: null,
				borderWidth: 1,
				itemHoverStyle: {
					color: '',
				},
			},
			plotOptions: {
				spline: {
					lineWidth: 4,

					marker: {
						radius: 5,
						states: {
							hover: {
								enabled: true,
								lineColor: 'rgb(100,100,100)',
							},
						},
					},
					states: {
						// hover: {
						//     marker: {
						//         enabled: false
						//     }
						// }
					},
					tooltip: {
						headerFormat: '<b style="color: #8C8C8C">{point.key}</b><br>',
						pointFormat: '<div style="color: #8C8C8C">{point.x}, {point.y}</div>',
					},
				},
				series: {
					stickyTracking: false,
				},
			},
			credits: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			series: [
				{
					name: '',
					color: 'rgba(119, 152, 191, .5)',
					type: 'scatter',
					showInLegend: false,
					data: [
						{ name: 'Point 1', x: 1, y: 2 },
						{ name: 'Point 2', x: 4, y: 5 },
					],
				},
			],
			accessibility: {
				enabled: false,
			},
		};

		return splinePlotOptions;
	}

	static redrawChart(chart: Chart) {
		chart.ref$.subscribe((chartRef) => {
			chartRef.redraw();
		});
	}
}
